@if (isSchemaReady()) {
<!-- Formly handles ONLY the dynamic section -->
<form [formGroup]="form">
  <div class="dynamic-plugin-section">
    <formly-form
      [form]="pluginValuesGroup"
      [fields]="dynamicFields()"
      [model]="model.plugin_values"
    >
    </formly-form>
  </div>
</form>
}
